"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTitleButtons = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const react_router_dom_1 = require("react-router-dom");
const generic_1 = require("./generic");
const hooks_1 = require("./hooks");
const feature_flags_1 = require("../feature-flags");
const hooks_2 = require("../hooks");
const icons_1 = require("../icons");
const localization_1 = require("../localization");
const router_1 = require("../router");
const PageTitleButtons = ({ isCompleted, selectedCatalogId, setIsUploadDataDialogOpen, getCatalogDownloadUrl, loading, disableCatalogActions, }) => {
    const { formatMessage: t, formatDate } = (0, localization_1.useLocalization)();
    const { featureFlagsService } = (0, hooks_2.useFeatureFlagsService)();
    const { addSuccess, addError } = (0, hooks_2.useNotification)();
    const isDashboardEnabled = featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.EnrichAIDashboard);
    const isStrategyMatrixEnabled = featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.StrategyMatrix);
    const isSyncWithGlobalTreeEnabled = featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.SyncWithGlobalTree);
    const { showSyncButton, lastSyncTimestamp, isSyncing, handleSync: syncWithGlobalTree, } = (0, hooks_1.useSyncWithGlobalTree)({
        selectedCatalogId,
        skip: !isSyncWithGlobalTreeEnabled,
    });
    const handleSync = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield syncWithGlobalTree();
            addSuccess(t({ key: 'SYNC_WITH_GLOBAL_TREE_SUCCESS' }));
        }
        catch (error) {
            console.error('Sync with Global Tree failed', error);
            addError(t({ key: 'SYNC_WITH_GLOBAL_TREE_ERROR' }));
        }
    }), [syncWithGlobalTree, addSuccess, addError, t]);
    return (react_1.default.createElement(react_1.default.Fragment, null, showSyncButton && (react_1.default.createElement(react_1.default.Fragment, null, lastSyncTimestamp && (react_1.default.createElement("span", { className: "last-synced-label" }, t({
        key: 'SYNC_WITH_GLOBAL_TREE_LAST_SYNCED',
        values: {
            date: formatDate(lastSyncTimestamp, {
                dateStyle: 'long', timeStyle: 'short',
            }),
        },
    }))), react_1.default.createElement(ui_components_1.Button, { rounded: true, className: "title-action", onClick: handleSync, variant: "outlined", disabled: isSyncing || disableCatalogActions, endIcon: isSyncing ? react_1.default.createElement(generic_1.LoadingIndicator, { className: "loading-indicator" }) : undefined }, t({ key: 'SYNC_WITH_GLOBAL_TREE_BUTTON' })))), react_1.default.createElement(ui_components_1.Button, { rounded: true, className: "title-action", onClick: () => setIsUploadDataDialogOpen(true), variant: "outlined", disabled: disableCatalogActions }, t({ key: 'UPLOAD_FILE_BUTTON_TITLE' })), isCompleted && (react_1.default.createElement(ui_components_1.Button, { rounded: true, className: "title-action", onClick: getCatalogDownloadUrl, disabled: loading, variant: "outlined", endIcon: loading
            ? react_1.default.createElement(generic_1.LoadingIndicator, { className: "loading-indicator" })
            : react_1.default.createElement(icons_1.DownloadIcon, { width: 16, height: 16, color: ui_components_1.baseColors.background200 }) }, t({ key: 'DOWNLOAD_CATALOG_BUTTON' }))), isStrategyMatrixEnabled && (react_1.default.createElement(react_router_dom_1.Link, { to: `/${router_1.ENRICH}/${router_1.EnrichSection.EnrichAI}/${router_1.EnrichSection.StrategyMatrix}` }, react_1.default.createElement(ui_components_1.Button, { rounded: true, className: "title-action", disabled: !selectedCatalogId, variant: "outlined" }, t({ key: 'GO_TO_STRATEGY_MATRIX' })))), isDashboardEnabled && (react_1.default.createElement(react_router_dom_1.Link, { to: `/${router_1.ENRICH}/${router_1.EnrichSection.EnrichAI}` }, react_1.default.createElement(ui_components_1.Button, { rounded: true, disabled: !selectedCatalogId, variant: "contained", color: "primary" }, t({ key: 'GO_TO_OVERVIEW' }))))));
};
exports.PageTitleButtons = PageTitleButtons;
